<template>
  <VanDialog
    :value="isShow"
    :show-confirm-button="false"
    :show-cancel-button="false"
    class-name="protocol-dialog"
    @click-overlay="onClose"
    @close="onClose"
  >
    <div v-if="content && isShow" class="container">
      <iframe :src="content" frameborder="0" width="100%" height="100%"></iframe>
      <div class="bottom">
        <div class="btn" @click="onConfirm">同意</div>
      </div>
    </div>
  </VanDialog>
</template>

<script>
export default {
  name: "ProtocolDialog",
  model: {
    prop: "isShow",
    event: "change",
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClose() {
      this.$emit("change", false);
    },
    onConfirm() {
      this.onClose();
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 60vh;
  display: flex;
  flex-direction: column;
  .bottom {
    height: 88px;
    background: #ffffff;
    box-shadow: inset 0px 1px 0px 0px #eeeeee;
    border-radius: 0px 0px 20px 20px;
    padding: 0 14px;
    display: flex;
    align-items: center;
  }
  .btn {
    width: 100%;
    height: 48px;
    background: #006efa;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    text-align: center;
    font-style: normal;
  }
}
.protocol-dialog {
  width: calc(100% - 20px);
  top: unset;
  bottom: calc(24px + constant(safe-area-inset-bottom));
  bottom: calc(24px + env(safe-area-inset-bottom));
  border-radius: 28px;
  padding: 0;
  transform: translate3d(-50%, 0, 0);
  ::v-deep .van-dialog__header {
    padding: 0;
    width: 100% !important;
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    text-align: center;
    font-style: normal;
    border-bottom: 1px solid #eeeeee;
  }
  ::v-deep .van-dialog__footer {
    border: none;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #006efa;
    line-height: 22px;
    text-align: center;
    font-style: normal;
  }
}
</style>
